export const moduleNamespace = 'libAmCommon';
